import {ChangeDetectionStrategy, Component, computed, Inject, InjectionToken, input} from "@angular/core";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {ArkivMappenodeDLM} from "felles-ng2/tjenester/datalager/ArkivDatatjeneste";
import {kanArkivnodeRedigeres} from "felles-ng2/modell/arkivModellHjelpere";

/**  InjectionToken for injisering av {@link DelegerteMappevisningOperasjoner} implementasjon. */
export const DelegerteMappevisningOperasjoner_DI_TOKEN = new InjectionToken<DelegerteMappevisningOperasjoner>('DelegerteMappevisningOperasjoner implementasjon');

@Component({
    selector: 'abstrakt-mappevisning',
    template: '',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class MappevisningBasisKomponent {

    mappe = input.required<ArkivMappenodeDLM>();

    redigeringMulig = computed(() => kanArkivnodeRedigeres(this.mappe(), this.kontekst.autentisertBruker()));

    constructor(@Inject(DelegerteMappevisningOperasjoner_DI_TOKEN) protected delegerteOperasjoner: DelegerteMappevisningOperasjoner, protected kontekst: BrukerkontekstTilbyder) {
    }

    visSkjerming() {
        this.delegerteOperasjoner.visSkjerming(this.mappe());
    }

}


/** Operasjoner som MappevisningBasisKomponent ikke selv kan realisere, men som noen høyere opp i komponent-treet må realisere */
export interface DelegerteMappevisningOperasjoner {
    visSkjerming(mappe: ArkivMappenodeDLM): void;
}
